
































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "equipoplogs/getLogs";

  stadiumGrounds: any[] = [];

  mainEquipOptions: any[] = [
    {
      id: 1,
      name: "AI主机"
    },
    {
      id: 2,
      name: "人脸识别"
    },
    {
      id: 3,
      name: "二维码识别"
    },
    {
      id: 4,
      name: "UPS断电保护"
    },
    {
      id: 5,
      name: "摄像头主机"
    },
    {
      id: 6,
      name: "升降机"
    }
  ];

  subEquipArr: any[] = [
    {
      id: "1",
      name: "门禁"
    },
    {
      id: "6",
      name: "行为识别"
    },
    {
      id: "7",
      name: "应急门"
    },
    {
      id: "8",
      name: "门禁灯"
    },
    {
      id: "9",
      name: "门禁开闭监视器"
    },
    {
      id: "10",
      name: "门禁警报器"
    },
    {
      id: "11",
      name: "智慧路灯"
    },
    {
      id: "3",
      name: "照明灯"
    },
    {
      id: "4",
      name: "广告灯"
    },
    {
      id: "2",
      name: "场地灯"
    },
    {
      id: "5",
      name: "升降机"
    }
  ];

  usertypeArr: any[] = [
    {
      id: 1,
      name: "普通用户"
    },
    {
      id: 2,
      name: "教练"
    },
    {
      id: 3,
      name: "巡馆员"
    },
    {
      id: 4,
      name: "馆长"
    },
    {
      id: 5,
      name: "管理员"
    },
    {
      id: 6,
      name: "成员"
    },
    {
      id: 7,
      name: "商务人员"
    },
    {
      id: 8,
      name: "财务人员"
    },
    {
      id: 9,
      name: "客服人员"
    },
    {
      id: 10,
      name: "城市经理"
    },
    {
      id: 11,
      name: "工程部人员"
    },
    {
      id: 12,
      name: "研发人员"
    },
    {
      id: 13,
      name: "总裁办"
    }
  ];

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "时间",
      dataIndex: "created_time"
    },
    {
      title: "场地",
      dataIndex: "ground_name"
    },
    {
      title: "设备类型",
      scopedSlots: { customRender: "e_type" }
    },
    {
      title: "设备",
      scopedSlots: { customRender: "e_id" }
    },
    {
      title: "设备子分类",
      scopedSlots: { customRender: "e_sub_type" }
    },
    {
      title: "操作类型",
      scopedSlots: { customRender: "opt_type" }
    },
    {
      title: "操作人",
      dataIndex: "username"
    },
    {
      title: "操作人手机号",
      dataIndex: "user_mobile"
    },
    {
      title: "操作平台",
      dataIndex: "service_name"
    },
    {
      title: "操作原因",
      dataIndex: "opt_reason"
    },
    {
      title: "操作备注",
      dataIndex: "opt_desc"
    },
    {
      title: "事件类型",
      scopedSlots: { customRender: "event_type" }
    },
    // {
    //   title: '用户类型',
    //   scopedSlots: { customRender: 'user_type' }
    // },
    {
      title: "是否是主馆长",
      scopedSlots: { customRender: "is_main" }
    }
  ];

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
